// Miky Motorsport - Rapier fyzikalni svet (async WASM init)
// rapier3d-compat: WASM je base64-embedded => await RAPIER.init() pred prvnim pouzitim
// (zvoleno kvuli Vite top-level-await kompatibilite).
import RAPIER from '@dimforge/rapier3d-compat';
import { PHYS, FIXED_DT } from '../constants.js';

let initialized = false;

// Inicializace Rapier WASM. Volat jednou v async bootu pred vytvorenim sveta.
export async function initRapier() {
  if (!initialized) {
    await RAPIER.init();
    initialized = true;
  }
  return RAPIER;
}

export function isReady() {
  return initialized;
}

// Vytvori novy fyzikalni svet s fixnim timestepem.
export function createWorld() {
  if (!initialized) throw new Error('initRapier() musi byt zavolano pred createWorld()');
  const world = new RAPIER.World({ x: 0, y: PHYS.GRAVITY, z: 0 });
  world.timestep = FIXED_DT / PHYS.SUBSTEPS;
  return world;
}

// Jeden fyzikalni krok (vc. substepu pro vysoke rychlosti).
// vehicleStep: callback volany pred kazdym world.step() (aplikuje vehicle controllery).
export function stepWorld(world, vehicleStep) {
  const dt = world.timestep;
  for (let s = 0; s < PHYS.SUBSTEPS; s++) {
    if (vehicleStep) vehicleStep(dt);
    world.step();
  }
}

export { RAPIER };
